import axios from "axios";
export const API_URL = "https://srinivasafleet.com/api";


const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

export const getProfile = async (userId) => {
  const res = await api.get(`/settings/profile/${userId}`);
  return res.data;
};

export const updateProfile = async (userId, payload) => {
  const res = await api.put(`/settings/profile/${userId}`, payload);
  return res.data;
};

export const changePassword = async (userId, currentPassword, newPassword) => {
  const res = await api.put(`/settings/change-password/${userId}`, {
    current_password: currentPassword,
    new_password:     newPassword,
  });
  return res.data;
};

export const getNotifications = async (userId) => {
  const res = await api.get(`/settings/notifications/${userId}`);
  return res.data;
};

export const markNotificationRead = async (userId, notifId) => {
  const res = await api.put(`/settings/notifications/${userId}/read/${notifId}`);
  return res.data;
};

export const markAllNotificationsRead = async (userId) => {
  const res = await api.put(`/settings/notifications/${userId}/read-all`);
  return res.data;
};

export const getAppInfo = async () => {
  const res = await api.get("/settings/app-info");
  return res.data;
};